import PropTypes from 'prop-types'
import React, { Component } from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { connect } from 'react-redux'
import { Map } from 'immutable'
import FormsyForm from 'formsy-react'
import _partial from 'lodash/partial'
import _isFunction from 'lodash/isFunction'
import _parseInt from 'lodash/parseInt'
import { getBoundActions } from '../../actions/index'
import Button, { TYPES } from '../Button/index'
import { Textarea } from '../FormInput.v2/index'
import UserAvatar from '../UserAvatar/index'
import SendIcon from '../Icon/icons/Send/index'
import { COMMENT_GA4_EVENT } from '../../services/event-tracking/index'
import { selectCurrentUserProfilePicture } from '../../services/community/identity/profile/redux/selectors'

function getClassNameTextarea (props, state) {
  const { canSubmit, hasFocus } = state
  const isExpanded = hasFocus || (!hasFocus && canSubmit)
  return ['comment-edit__textarea'].concat(
    isExpanded ? ['comment-edit__textarea--expanded'] : [],
  )
}

class CommentEdit extends Component {
  constructor (props) {
    super(props)
    this.state = {
      canSubmit: false,
      hasFocus: false,
    }
  }

  onChangeForm = (values) => {
    this.setCanSubmit(values.body !== '')
  }

  onValidSubmit = (model, resetForm) => {
    const { resetState } = this
    const {
      data,
      parent,
      comment,
      createComment,
      updateComment,
      onSubmitComplete,
      isHeaderComment,
      setEventDefault,
    } = this.props
    const { body } = model

    if (body !== '') {
      resetState()

      if (_isFunction(onSubmitComplete)) {
        onSubmitComplete(model)
      }

      if (comment && comment.id) {
        // Editing an existing comment
        updateComment(comment.id, body)
      } else {
        // Creating a new comment
        const pid = parent ? _parseInt(parent.id) : undefined
        createComment(body, pid)
      }

      resetForm()

      if (isHeaderComment && data) {
        // GA4 event
        const eventData = COMMENT_GA4_EVENT
          .mergeDeep({
            content_name: data.get('title'),
            content_id: data.get('id'),
            content_type: data.get('contentType'),
            parent_series_id: data.get('seriesId'),
            parent_series_name: data.get('seriesTitle'),
          })

        setEventDefault(eventData)
      }
    }
  }

  setHasFocus = (hasFocus) => {
    this.setState(() => ({ hasFocus }))
  }

  setCanSubmit = (canSubmit) => {
    this.setState(() => ({ canSubmit }))
  }

  resetState = () => {
    this.setState(() => ({ canSubmit: false, hasFocus: false }))
  }

  render () {
    const {
      props, state, onValidSubmit, onChangeForm, setHasFocus,
    } = this
    const {
      className,
      placeholder,
      auth,
      user,
      comment,
      commentEditStaticText,
      showAvatar,
      currentUserPicture,
    } = props
    const { canSubmit } = state
    if (!auth.get('jwt')) {
      return null
    }
    return (
      <FormsyForm
        className={['comment-edit'].concat(className || []).join(' ')}
        onValidSubmit={onValidSubmit}
        onChange={onChangeForm}
      >
        {showAvatar && <UserAvatar
          path={(currentUserPicture && currentUserPicture.small) || user.getIn(['data', 'avatar', 'small'], '')}
          name={user.getIn(['data', 'name'])}
        />}
        <div className={getClassNameTextarea(props, state).join(' ')}>
          <Textarea
            name="body"
            value={comment ? comment.comment : ''}
            onFocus={_partial(setHasFocus, true)}
            onBlur={_partial(setHasFocus, false)}
            label={commentEditStaticText.getIn(['data', 'shareYourThoughts'])}
            labelHidden
            placeholder={
              placeholder || commentEditStaticText.getIn(['data', 'shareYourThoughts'])
            }
          />
          <Button
            type={TYPES.ICON}
            submit
            className="comment-edit__button-submit"
            iconSvg={<SendIcon />}
            disabled={!canSubmit}
          />
        </div>
      </FormsyForm>
    )
  }
}

CommentEdit.propTypes = {
  comment: PropTypes.object,
  parent: PropTypes.object,
  placeholder: PropTypes.string,
  data: ImmutablePropTypes.map,
  auth: ImmutablePropTypes.map.isRequired,
  app: ImmutablePropTypes.map.isRequired,
  page: ImmutablePropTypes.map.isRequired,
  media: ImmutablePropTypes.map.isRequired,
  video: ImmutablePropTypes.map.isRequired,
  createComment: PropTypes.func,
  updateComment: PropTypes.func,
  onSubmitComplete: PropTypes.func,
  commentEditStaticText: ImmutablePropTypes.map.isRequired,
  location: PropTypes.object,
  isHeaderComment: PropTypes.bool,
  setEventDefault: PropTypes.func,
  showAvatar: PropTypes.bool,
}

export default connect(
  (state) => ({
    commentEditStaticText: state.staticText.getIn(
      ['data', 'commentEdit'],
      Map(),
    ),
    auth: state.auth,
    app: state.app,
    page: state.page,
    media: state.media,
    video: state.video,
    user: state.user,
    currentUserPicture: selectCurrentUserProfilePicture(state),
  }),
  (dispatch) => {
    const actions = getBoundActions(dispatch)
    return {
      setEventDefault: actions.eventTracking.setEventDefault,
    }
  },
)(CommentEdit)
